// ── Service de Cards (núcleo/aplicação) ───────────────────────────
// Regras do ciclo de vida do card. Recebe o repositório via porta (DI).

import type {
  ICardRepository,
  MarkCardLostResult,
  CardActiveWithGraph,
  CardLostWithGraph,
  CardFinancialCount,
  OverwriteCardForMoveParams,
} from '../ports/ICardRepository';

export class CardService {
  constructor(private readonly repo: ICardRepository) {}

  markCardLost = (cardId: string, lossReason: string): Promise<MarkCardLostResult> => {
    if (!cardId) throw new Error('cardId e obrigatorio.');
    return this.repo.markCardLost(cardId, lossReason);
  };

  listActiveCardsByLead = (leadId: string): Promise<CardActiveWithGraph[]> => {
    if (!leadId) return Promise.resolve([]);
    return this.repo.listActiveCardsByLead(leadId);
  };

  listLostCardsByLead = (leadId: string): Promise<CardLostWithGraph[]> => {
    if (!leadId) return Promise.resolve([]);
    return this.repo.listLostCardsByLead(leadId);
  };

  reactivateCards = (cardIds: string[]): Promise<void> => {
    if (!cardIds?.length) return Promise.resolve();
    return this.repo.reactivateCards(cardIds);
  };

  deactivateCard = (cardId: string): Promise<void> => {
    if (!cardId) throw new Error('cardId e obrigatorio.');
    return this.repo.deactivateCard(cardId);
  };

  deleteCard = (cardId: string): Promise<void> => {
    if (!cardId) throw new Error('cardId e obrigatorio.');
    return this.repo.deleteCard(cardId);
  };

  countCardFinancials = (cardId: string): Promise<CardFinancialCount> => {
    if (!cardId) return Promise.resolve({ commissions: 0, sales: 0 });
    return this.repo.countCardFinancials(cardId);
  };

  assignActiveCardsOwner = (
    leadId: string,
    field: 'sdr_id' | 'closer_id',
    userId: string | null,
  ): Promise<void> => {
    if (!leadId) throw new Error('leadId e obrigatorio.');
    return this.repo.assignActiveCardsOwner(leadId, field, userId);
  };

  moveCardToStage = (cardId: string, stageId: string): Promise<void> => {
    if (!cardId) throw new Error('cardId e obrigatorio.');
    return this.repo.moveCardToStage(cardId, stageId);
  };

  deactivateCardsByLead = (leadId: string): Promise<void> => {
    if (!leadId) throw new Error('leadId e obrigatorio.');
    return this.repo.deactivateCardsByLead(leadId);
  };

  moveCardToPipeline = (cardId: string, pipelineId: string, stageId: string): Promise<void> => {
    if (!cardId) throw new Error('cardId e obrigatorio.');
    return this.repo.moveCardToPipeline(cardId, pipelineId, stageId);
  };

  overwriteCardForMove = (cardId: string, params: OverwriteCardForMoveParams): Promise<void> => {
    if (!cardId) throw new Error('cardId e obrigatorio.');
    return this.repo.overwriteCardForMove(cardId, params);
  };
}
